import { html, type TemplateResult } from 'lit-html';

export function when(iso: string | null | undefined): string {
  if (!iso) return '—';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return iso;
  return d.toLocaleString(undefined, { month: 'short', day: 'numeric', year: d.getFullYear() === new Date().getFullYear() ? undefined : 'numeric', hour: 'numeric', minute: '2-digit' });
}

export function ago(iso: string | null | undefined): string {
  if (!iso) return '—';
  const s = Math.round((Date.now() - new Date(iso).getTime()) / 1000);
  if (s < 0) {
    const f = -s;
    if (f < 3600) return `in ${Math.max(1, Math.round(f / 60))}m`;
    if (f < 86400) return `in ${Math.round(f / 3600)}h`;
    return `in ${Math.round(f / 86400)}d`;
  }
  if (s < 60) return `${s}s ago`;
  if (s < 3600) return `${Math.round(s / 60)}m ago`;
  if (s < 86400) return `${Math.round(s / 3600)}h ago`;
  return `${Math.round(s / 86400)}d ago`;
}

export function pill(text: string, tone = 'neutral'): TemplateResult {
  return html`<span class="pill ${tone}">${text}</span>`;
}

const MAIL_TONE: Record<string, string> = {
  queued: 'info',
  sending: 'info',
  submitted: 'accent',
  received: 'accent',
  producing: 'accent',
  handed_over: 'accent',
  in_transit: 'accent',
  local_delivery: 'accent',
  delivered: 'positive',
  returned: 'critical',
  failed: 'critical',
  cancelled: 'neutral',
  test: 'neutral',
};
const MAIL_LABEL: Record<string, string> = {
  queued: 'Held',
  sending: 'Sending',
  submitted: 'Sent to Stannp',
  received: 'Received by Stannp',
  producing: 'Printing',
  handed_over: 'Handed to USPS',
  in_transit: 'In transit',
  local_delivery: 'Out for delivery',
  delivered: 'Delivered',
  returned: 'Returned',
  failed: 'Failed',
  cancelled: 'Cancelled',
  test: 'Test (not posted)',
};
export const mailLabel = (s: string) => MAIL_LABEL[s] ?? s.replace(/_/g, ' ');
export const mailPill = (s: string) => pill(mailLabel(s), MAIL_TONE[s] ?? 'neutral');
